
import showMore from '@/mixins/showMore'
export default {
  props: {
    item: Object,
  },
  mixins: [showMore],
}
